<template>
  <ContentInfoLinks :links="links" />
</template>

<script>
import ContentInfoLinks from 'chimera/all/themes/blueflow/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      links: [
        {
          title: 'Algemeen',
          to: '/informatie-over-verhuizers/',
        },
        {
          title: 'Particuliere verhuizing',
          to: '/informatie-over-verhuizers/particuliere-verhuizingen',
        },
        {
          title: 'Zakelijke verhuizing',
          to: '/informatie-over-verhuizers/zakelijke-verhuizingen',
        },
        {
          title: 'Internationale verhuizing',
          to: '/informatie-over-verhuizers/internationale-verhuizingen',
        },
        {
          title: 'Emigreren',
          to: '/informatie-over-verhuizers/emigreren',
        },
        {
          title: 'Verhuisservice',
          to: '/informatie-over-verhuizers/verhuisservice',
        },
        {
          title: 'Verhuisbedrijf',
          to: '/informatie-over-verhuizers/verhuisbedrijf',
        },
        {
          title: 'Verhuistips',
          to: '/informatie-over-verhuizers/verhuistips',
        },
        {
          title: 'Bpost verhuisdienst',
          to: '/informatie-over-verhuizers/bpost-verhuisservice',
        },
        {
          title: 'Verhuisdozen',
          to: '/informatie-over-verhuizers/verhuisdozen',
        },
        {
          title: 'Verhuizen checklist',
          to: '/informatie-over-verhuizers/verhuizen-checklist',
        },
      ],
    }
  },
}
</script>
